import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
import ReactPlayer from "react-player";
import { serverInfo } from "../../../../App";
// import "./AuditionCardReuse.css";

const JuryMarkedTable = (props) => {
  const { videoCdnUrl } = useContext(serverInfo);

  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 4;
  const { data, handleSelectedVideo, myGroup } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <div className="py-3">
        <div className="row d-flex justify-content-center">
          {currentItems.map((video, index) => {
            return (
              <div
                key={index}
                className="col-md-4"
                onClick={() => handleSelectedVideo(video)}
                style={{
                  height: "200px",
                  width: "290px",
                }}
              >
                <div>
                  <ReactPlayer
                    url={videoCdnUrl + video?.video}
                    playing={false}
                    controls
                    height={190}
                    width={260}
                    style={{ cursor: "pointer" }}
                  />

                  <div className="text-center">
                    <span
                      style={{ color: "rgb(34 211 238)" }}
                      className=" fw-bolder"
                    >
                      Mark:{" "}
                      <strong>
                        {myGroup === "b"
                          ? video.group_b_jury_mark
                          : video.group_c_jury_mark}
                      </strong>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div id="react-paginate" className="mt-3">
        <ReactPaginate
          breakLabel="..."
          nextLabel="next >"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          pageCount={pageCount}
          previousLabel="< previous"
          renderOnZeroPageCount={null}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageLinkClassName={"page-link"}
          previousLinkClassName={"page-link"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
        />
      </div>
    </>
  );
};

export default JuryMarkedTable;
